// @ts-nocheck
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import { RestApiService } from '../service/rest-api.service';

@Pipe({
  name: 'secureFile',
})
export class SecureFilePipe implements PipeTransform {
  constructor(
    protected sanitizer: DomSanitizer,
    protected restApi: RestApiService,
  ) { }

  public transform(key: string, bucket: 'default' | 'regulatory_reports' = 'default'): Observable<string | ArrayBuffer> {
    return new Observable<string | ArrayBuffer>((observer) => {
      // immediate resolve a tiny blank image
      observer.next('data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==');
      // resolve secure file

      let observable: Observable<any>;

      switch (bucket) {
        case 'regulatory_reports':
          observable = this.restApi
            .getRegulatoryReport_admin(key);
          break;
        case 'default':
        default:
          observable = this.restApi
            .getFile(key);
          break;
      }

      observable
        .toPromise()
        .then((response) => {
          const reader = new FileReader();
          reader.readAsDataURL(response);
          reader.onerror = (error) => observer.error(error);
          reader.onloadend = () => {
            const dataURI = reader.result;
            observer.next(dataURI);
            observer.complete();
          };
        })
        .catch((error) => observer.error(error));
    });
  }
}
